<template>
	<table class="b-table table table-striped b-table-stacked-md">
		<thead>
			<tr>
				<th>Nome Completo</th>
				<th>Posição Familiar</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="familiar in familiares" :key="familiar.id">
				<td>
					<strong>{{ familiar.nome_completo }}</strong>
					<br />
					<span v-if="familiar.documento">
						<span v-if="familiar.documento.nis">NIS: {{ familiar.documento.nis }}</span>
						<span v-else>
							<b-link
								href="#"
								v-b-tooltip.hover
								title="Não sabe o número do NIS ou não foi inserido no cadastro!"
							>
								NIS:
								<b-icon
									icon="exclamation-triangle-fill"
									variant="warning"
									animation="fade"
								></b-icon>
							</b-link>
						</span>
					</span>
					<br />
					Sexo:
					<span v-if="familiar.sexo == 1"> MASCULINO </span>
					<span v-if="familiar.sexo == 2"> FEMININO </span>
					<span v-else> INTERSEXO </span>
					<br />
					Idade: {{ familiar.idade }} ano(s)
				</td>
				<td v-if="organizar">
					<form-select
						v-model="familiar.posicao_familiar"
						:itens="$root.arrays.posicao_familiar_sr"
					/>
				</td>
				<td v-else>
					<form-select
						v-model="familiar.posicao_familiar"
						:itens="$root.arrays.posicao_familiar_sr"
					/>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	props: ["familiares", "organizar"],
};
</script>
